import React from 'react'

export default function IconboxStyle1({imgUrl, titleUp, title, textColor}) {
  return (
    <div className="d-flex align-items-center">
      <div className="d-flex align-items-center justify-content-center cs_height_70 cs_width_70 cs_height_lg_80 cs_width_lg-80 cs_rounded_10 flex-none cs_mr_20 bg-accent">
        <img src={imgUrl} alt="contact-icon" />
      </div>
      <div>
        <p className="text-accent cs_mb_7">{titleUp}</p>
        <p className={`${textColor}`}>
          {title}
        </p>
      </div>
    </div>
  )
}
